import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { LocalizedDatePipe } from '../../../../shared/pipes/localized-date.pipe';

@Component({
    selector: 'app-copyright',
    templateUrl: './copyright.component.html',
    styleUrls: ['./copyright.component.scss'],
    imports: [TranslateModule, LocalizedDatePipe]
})
export class CopyrightComponent implements OnInit,OnDestroy  {
  private translate = inject(TranslateService);

  isWebMobile = window.innerWidth < 576;
  
  today: number = Date.now();
  langChangeSubscription: Subscription;

  footerMenu : any[]
  footerMenuLeft : any[]
  footerMenuRight : any[]
  footerMenuMobileLeft : any[]
  footerMenuMobileRight : any[]

  ngOnInit() {
    this.translate.get(['footerMenu', 'footerMenuLeft', 'footerMenuRight', 'footerMenuMobileLeft', 'footerMenuMobileRight']).subscribe((res: any) => {
      this.footerMenu = res.footerMenu;
      this.footerMenuLeft = res.footerMenuLeft;
      this.footerMenuRight = res.footerMenuRight;
      this.footerMenuMobileLeft = res.footerMenuMobileLeft;
      this.footerMenuMobileRight = res.footerMenuMobileRight;
      this.getFooterItems();
     });

    this.langChangeSubscription = this.translate.onLangChange.subscribe((event) => {
    this.footerMenu = event.translations.footerMenu;
    this.footerMenuLeft = event.translations.footerMenuLeft;
    this.footerMenuRight = event.translations.footerMenuRight;
    this.footerMenuMobileLeft = event.translations.footerMenuMobileLeft;
    this.footerMenuMobileRight = event.translations.footerMenuMobileRight;
      this.getFooterItems();
    });
    
  }

  getFooterItems(){
    this.footerMenu = [
      this.footerMenu.slice(0, 3),
      this.footerMenu.slice(3, 6),
      this.footerMenu.slice(6, 9)
    ]   
  }
    

  ngOnDestroy(): void {
  
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }
}
